<div class="tab-pane fade show active details-view-results">
  <div class="expense-button">
    <div class="create-expense-button" *ngIf="canCreateExpense">
      <a (click)="onExportPatientExpenses(patientId)" class="btn btn-outline btn-outline-slim">Export</a>
    </div>
    <div class="create-expense-button" *ngIf="authService.hasPermission(Permissions.PatientExpenseWrite)">
      <a (click)="createExpenseModal.showForPatient(patientId)" class="btn btn-outline btn-outline-slim">+ Add
        Expense</a>
    </div>
  </div>
  <div *ngIf="results.policyReminders" class="policy-reminder">
    <span class="text">
      <span class="text-style-1">Policy Reminder:</span>
      {{ results.policyReminders }}
    </span>
  </div>


  <div class="patient-expense" *ngFor="let expense of results.results; let i = index;">
    <button
      *ngIf="(expense.state === 'Pending' || expense.state === 'Approved' || expense.state === 'Rejected') &&  authService.hasPermission(Permissions.PatientExpenseEditInvestigation)"
      (click)="onEditExpense(expense.id)" class="btn btn-secondary btn-slim btn-edit"
      [disabled]="expense.overBudgetRequestRaised && expense.state === 'Pending'">
      Edit
    </button>
    <a (click)="onStartInvestigation(expense.id)" class="btn btn-secondary btn-slim btn-edit"
       *ngIf="authService.hasPermission(Permissions.PatientExpenseEditInvestigation) && !expense.underInvestigation && expense.state === 'Pending'">
      Requires
      Investigation
    </a>
    <a (click)="onCloseInvestigation(expense.id)" class="btn btn-secondary btn-slim btn-edit btn-close-investigation"
       *ngIf="authService.hasPermission(Permissions.PatientExpenseWrite) && expense.underInvestigation && expense.state === 'Pending'">
      Close
      Investigation
    </a>

    <div class="badge-wrap">
      <span class="badge" [ngClass]="{'badge-warning': expense.state == 'Pending',
                                  'badge-success': (expense.state == 'AutomatedPaymentApproved' || expense.state == 'Processing' || expense.state == 'Approved'),
                                  'badge-danger': (expense.state == 'Rejected' || expense.state == 'AutomatedPaymentFailed'),
                                  'badge-grey': expense.state == 'Paid'}">
        {{ getBadgeLabel(expense.state) }}
      </span>

      <span class="label" *ngIf="expense.state === 'AutomatedPaymentApproved' && expense.dateApproved">
        on {{ expense.dateApproved | date: 'd MMM yyyy' }} at {{
          expense.dateApproved | date: 'h:mm aaa'
        }}
      </span>

      <span class="label" *ngIf="expense.state === 'Rejected' && expense.dateRejected">
        on {{ expense.dateRejected | date: 'd MMM yyyy' }} at {{
          expense.dateRejected | date: 'h:mm aaa'
        }}
      </span>

      <span class="label" *ngIf="expense.state === 'Paid' && expense.datePaid">
        on {{ expense.datePaid | date: 'd MMM yyyy' }} at {{ expense.datePaid | date: 'h:mm aaa' }}
      </span>

      <span
        *ngIf="expense.state === 'Pending' && (expense.overBudgetRequestStatus !== null || expense.overBudgetRequestRaised)"
        class="over-budget over-budget-{{(expense.overBudgetRequestStatus | enumToText: OverBudgetRequestDetailsStatus)?.replace(' ', '-') | lowercase}}">
        <mat-icon>error</mat-icon>
        Over budget - {{
          expense.overBudgetRequestStatus !== null ? (expense.overBudgetRequestStatus | enumToText:
            OverBudgetRequestDetailsStatus) : 'Pending'
        }} decision
      </span>
      <span class="over-budget referred-back" *ngIf="expense.state === 'Pending' && expense.referredBack">
        <mat-icon>error</mat-icon>
        Over budget - Referred back
      </span>
    </div>

    <span class="label submitted-date">
      {{ expense.addedByPatient ? 'Submitted by patient on ' : 'Created by administrator on ' }} {{
        expense.created |
          date:'d MMM yyyy'
      }} at {{ expense.created | date: 'h:mm aaa' }}
    </span>
    <span class="label visit-desc">
      {{ expense.visitType }}: {{ expense.visitTitle }}: {{
        expense.visitAttendance |
          enumToText: VisitAttendance
      }}
    </span>
    <span class="label visit-date">Visit date: {{
        expense?.visitDate ? (expense.visitDate | date: 'dd/MM/yyyy') :
          'N/A'
      }}
    </span>

    <div class="title-cost-wrap" *ngIf="expense.categoryType == 'Distance'">
      <span class="result-heading title">{{ expense.categoryName }}</span>
      <span class="result-heading cost">
        {{ expense.distanceAmount }} {{ expense.distanceUnit }}
        <span *ngIf="expense.amount > 0"> / {{ expense.currency }} {{ expense.amount | number:'1.2-2' }}</span>
      </span>
    </div>

    <app-expense-check-preview [patientExpense]="expense"></app-expense-check-preview>

    <div class="title-cost-wrap" *ngIf="expense.categoryType == 'Value'">
      <div class="left">
        <span class="result-heading title">
        <app-expense-ai-category
          [categoryName]="expense.categoryName"
          [hasAiData]="expense.state === 'Pending' && hasAiReceiptData(expense)"
          [matches]="receiptCategoryMatches(expense)"
          [mismatchReason]="categoryMismatchReason(expense)">
        </app-expense-ai-category>
        <span
          *ngIf="!stringHelper.isNullOrEmpty(expense.subCategoryName) && expense.subCategoryName !== 'None'">
          - {{
            expense.subCategoryName
          }}
        </span>
      </span>
        <span class="result-heading cost">
        <app-expense-ai-amount
          [currency]="expense.currency"
          [amount]="expense.amount"
          [hasAiData]="expense.state === 'Pending' && hasAiReceiptData(expense)"
          [matches]="receiptAmountMatches(expense)"
          [mismatchReason]="receiptMismatchReason(expense)"
          [showNegative]="expense.subCategoryName === 'Card Preload Redemption'">
        </app-expense-ai-amount>
      </span>
      </div>

      @if (expense.dailySpendExpensesEnabled && hasAiReceiptData(expense)) {
        <span class="result-heading receipt-date">
        <app-expense-ai-receipt-date [receipts]="expense.receipts" [visitDate]="expense.visitDate" [visitEndDate]="expense.visitEndDate" [visitTravelDays]="expense.visitTravelDays"></app-expense-ai-receipt-date>
      </span>
      }
    </div>

    <div class="desc">
      <p *ngIf="expense.policyReminders">{{ expense.policyReminders }}</p>
      <p *ngIf="expense.notes">{{ expense.notes }}</p>
    </div>

    <p class="rejected-reason orange" *ngIf="expense.underInvestigation">
      <strong>Reason for Investigation:</strong> {{
        expense.reasonForInvestigation
      }}
    </p>

    <p class="rejected-reason" *ngIf="expense.state == 'Rejected'">
      <strong>Rejection Reason:</strong> {{
        expense.rejectionReason
      }}
    </p>

    <app-expense-images [enableImagesManagement]="false" [imagery]="expense.imageUrls"
                        [expenseClaimId]="expense.id" [receipts]="expense.receipts"
                        [claimCategory]="expense.categoryName"
                        [claimAmount]="expense.amount" [claimCurrency]="expense.currency"
                        [visitDate]="expense.visitDate" [visitEndDate]="expense.visitEndDate"
                        [visitTravelDays]="expense.visitTravelDays"></app-expense-images>


    <ul *ngIf="expense.state !== 'Rejected'" class="actions">
      <li
        *ngIf="expense.state === 'Pending' && !expense.underInvestigation && authService.hasPermission(Permissions.PatientExpenseApproveReject)">
        <a (click)="onApproveExpenseClaim(expense.id, ExpenseCategoryType[expense.categoryType])"
           [class.disabled]="isExpenseProcessing(expense.id)"
           class="btn btn-primary btn-slim">Approve</a>
      </li>
      <li *ngIf="expense.state == 'Approved' && authService.hasPermission(Permissions.ExpenseWrite)">
        <a (click)="onMarkAsPaid(expense.id)" [class.disabled]="isExpenseProcessing(expense.id)"
           class="btn btn-primary btn-slim">Mark as Paid</a>
      </li>
      <li *ngIf="expense.state === 'Pending' && authService.hasPermission(Permissions.PatientExpenseApproveReject)">
        <button (click)="onRejectModal(expense.id)" [disabled]="expense.overBudgetRequestRaised"
                class="btn btn-outline btn-slim reject-button">
          Reject
        </button>
      </li>
      <li *ngIf="expense.state == 'Paid'">&nbsp;</li>
    </ul>
    <div class="clearfix"></div>

    <div class="reason-for-edit" *ngIf="expense.reasonsForEdit.length > 0">
      <label><i class="fas fa-pencil" aria-hidden="true"></i> Reasons for edit</label>
      <ul>
        <li *ngFor="let reason of expense.reasonsForEdit">
          {{ reason.created | date: 'd MMM yyyy' }} at {{ reason.created | date: 'h:mm aaa' }} -
          {{ reason.reason }}
        </li>
      </ul>
    </div>
  </div>

</div>

<app-pagination [currentPage]="results.currentPage" [totalPageCount]="results.totalPageCount"
                (pageSelected)="loadPatientExpenses($event)"></app-pagination>

<app-modal #approveDistanceModal>
  <div class="modal-content">
    <div class="modal-header">
      <h2 class="modal-title">Approve Distance Expense?</h2>
    </div>
    <div class="modal-body">
      <form class="modal-form-full-width" [formGroup]="approveDistanceForm">
        <div class="form-group">
          <label>Currency</label>
          <app-dropdown-input #currencySelect name="currency" [parentForm]="approveDistanceForm"
                              [options]="currencyOptions" placeholder="Select Currency..."
                              (selectValueChanged)="onCurrencySelectChanged($event)"></app-dropdown-input>
        </div>
        <div class="form-group">
          <label>Amount</label>
          <input type="text" class="form-control" formControlName="amount">
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <div class="row">
        <div class="col-6">
          <a (click)="approveDistanceModal.hide()" class="btn btn-secondary" data-dismiss="modal">Cancel</a>
        </div>

        <div class="col-6">
          <a (click)="onApproveDistanceExpenseClaim()" class="btn btn-primary"
             [ngClass]="{'disabled': !approveDistanceForm.valid || approveFormIsProcessing}">
            <span *ngIf="approveFormIsProcessing">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            </span>
            <span *ngIf="!approveFormIsProcessing">Approve</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</app-modal>

<app-modal #rejectExpenseModal>
  <div class="modal-content">
    <div class="modal-header">
      <h2 class="modal-title">Reject Expense</h2>
    </div>
    <div class="modal-body">
      <p>This rejection reason will be displayed to the patient in their app.</p>
      <form class="modal-form-full-width" [formGroup]="rejectForm">
        <div class="form-group">
          <label>Rejection Reason</label>
          <textarea class="form-control" formControlName="reason"></textarea>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <div class="row">
        <div class="col-6">
          <a (click)="rejectExpenseModal.hide()" class="btn btn-secondary" data-dismiss="modal">Cancel</a>
        </div>

        <div class="col-6">
          <a (click)="onConfirmRejectExpense()" class="btn btn-primary" [ngClass]="{'disabled': !rejectForm.valid}">
            <span *ngIf="rejectFormIsProcessing">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            </span>
            <span *ngIf="!rejectFormIsProcessing">Reject</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</app-modal>

<app-modal #confirmExpenseApprove>
  <div class="modal-content">
    <div class="modal-header">
      <h2 class="modal-title">Expense will go to manual payment</h2>
    </div>
    <div class="modal-body">
      <p>{{ caxtonIncompatibleData?.caxtonIncompatibleReason }}</p>
    </div>
    <div class="modal-footer">
      <div class="row">
        <div class="col-6">
          <a (click)="closeConfirmExpenseApproveModal()" class="btn btn-secondary" data-dismiss="modal">Cancel</a>
        </div>

        <div class="col-6">
          <a (click)="confirmExpenseClaimApproval()" class="btn btn-primary"
             [ngClass]="{'disabled': confirmExpenseClaimApprovalProcessing}">
            <span *ngIf="confirmExpenseClaimApprovalProcessing">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            </span>
            <span *ngIf="!confirmExpenseClaimApprovalProcessing">Continue</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</app-modal>

<app-create-expense-modal #createExpenseModal (expenseCreated)="reloadExpenses()"></app-create-expense-modal>
<app-edit-expense-modal #editExpenseModal (expenseUpdated)="reloadExpenses()"></app-edit-expense-modal>
<app-start-investigation-modal #startInvestigationModal
                               (refreshResult)="loadPatientExpenses(page)"></app-start-investigation-modal>
<app-close-investigation-modal #closeInvestigationModal
                               (refreshResult)="loadPatientExpenses(page)"></app-close-investigation-modal>
